import type { ListingStage } from '@/api/v4/project-listings.api';
import {
  DealStageName,
  ListingStageName,
} from '@/features/listing-stage/types';

import type {
  SpotlightStagePillStageKey,
  StagePillKey,
} from './spotlight-stage-pill.types';

const CANONICAL_STAGE_NAME_BY_PILL_KEY: Record<
  SpotlightStagePillStageKey,
  string
> = {
  deal: ListingStageName.deal,
  investment: DealStageName.investment,
  pilot: ListingStageName.pilot,
};

export const getSpotlightStageLabel = (
  stageKey: StagePillKey,
  listingStages: ListingStage[],
  editorsChoiceLabel: string,
): string => {
  if (stageKey === 'editorsChoice') {
    return editorsChoiceLabel;
  }

  const canonicalStageName = CANONICAL_STAGE_NAME_BY_PILL_KEY[stageKey];
  const listingStage = listingStages.find(
    stage => stage.name === canonicalStageName,
  );

  if (listingStage) {
    return listingStage.displayName ?? listingStage.name;
  }

  return canonicalStageName;
};
